import { defineCrestModule } from '@crest/platform-contracts/modules';
import { relationshipsContactNoteSnippetsCapability } from './contracts/relationships-contact-note-snippets.contract.js';
import { relationshipsNoteMergeFieldsCapability, relationshipsNoteMergeFieldsProviderId, } from './contracts/relationships-note-merge-fields.contract.js';
import { projectsProjectDetailLauncherCapability } from '@crest/module-projects/contracts/detail-launcher';
import { platformOptionalActionProviderHostCapability, platformOptionalFactProviderHostCapability, } from '@crest/platform-contracts/hosts';
import { relationshipsInsuranceClaimsPartiesCapability, relationshipsInsuranceClaimsPartiesProviderId, } from './contracts/relationships-insurance-claims-parties.contract.js';
import { relationshipsFinanceCommissionAttributionsCapability, relationshipsFinanceCommissionAttributionsProviderId, } from './contracts/relationships-finance-commission-attributions.contract.js';
import { relationshipsCustomerPortalIntakeAcceptanceCapability, relationshipsCustomerPortalIntakeAcceptanceProviderId, } from './contracts/relationships-customer-portal-intake.contract.js';
import { relationshipsAssistantContextCapability, relationshipsAssistantContextProviderId, } from './contracts/relationships-assistant-context.contract.js';
import { relationshipsImportCapability } from './contracts/relationships-import-capability.contract.js';
import { relationshipsImportResolutionCapability } from './contracts/relationships-import-resolution.contract.js';
import { relationshipsProjectContactImportCapability } from './contracts/relationships-project-contact-import.contract.js';
export const relationshipsModuleManifest = defineCrestModule({
    id: 'relationships',
    version: '1.0.0',
    kind: 'business',
    required: false,
    requires: ['platform', 'projects'],
    requiredCapabilities: [
        'platform.tenant-context.v1',
        'platform.module-access.v1',
        'projects.projects.v1',
        'projects.record-policy.v2',
        'projects.detail-host.v1',
        projectsProjectDetailLauncherCapability,
        'projects.lead-intake.v1',
        platformOptionalActionProviderHostCapability,
        platformOptionalFactProviderHostCapability,
        'projects.import-resolution.v1',
    ],
    optionalCapabilities: [relationshipsContactNoteSnippetsCapability],
    optionalCapabilityFallbacks: [{
            capability: relationshipsContactNoteSnippetsCapability,
            degradedMode: 'relationships.degraded.manual-contact-note-entry.v1',
        }],
    provides: [
        'relationships.contacts.v1',
        'relationships.organizations.v1',
        'relationships.leads.v1',
        'relationships.lead-scoring.v1',
        'relationships.notes.v1',
        'relationships.outbound-authorization.v1',
        relationshipsInsuranceClaimsPartiesCapability,
        relationshipsFinanceCommissionAttributionsCapability,
        relationshipsCustomerPortalIntakeAcceptanceCapability,
        relationshipsAssistantContextCapability,
        relationshipsImportCapability,
        relationshipsImportResolutionCapability,
        relationshipsProjectContactImportCapability,
        relationshipsNoteMergeFieldsCapability,
    ],
    permissions: [
        'relationships.contacts.read',
        'relationships.contacts.create',
        'relationships.contacts.update',
        'relationships.contacts.delete',
        'relationships.contacts.private-details.read',
        'relationships.organizations.create',
        'relationships.organizations.update',
        'relationships.organizations.delete',
        'relationships.leads.read',
        'relationships.leads.create',
        'relationships.leads.update',
        'relationships.leads.convert',
        'relationships.leads.delete',
        'relationships.leads.assign-any',
        'relationships.referral-sources.manage',
        'relationships.referral-attributions.read',
        'relationships.lead-scoring.manage',
        'relationships.notes.read',
        'relationships.notes.create',
        'relationships.notes.update',
        'relationships.notes.delete',
        'relationships.import.read',
        'relationships.import.execute',
        'relationships.import.rollback',
    ],
    settings: ['relationships.projects.customer-panel.enabled'],
    copyCatalogs: [
        'relationships.copy.organization-notes',
        'relationships.copy.organization-edit',
        'relationships.copy.organization-detail',
        'relationships.copy.contact-edit',
        'relationships.copy.contact-note-snippets',
        'relationships.copy.contact-detail',
        'relationships.copy.contacts',
        'relationships.copy.project-customer',
        'relationships.copy.organizations',
        'relationships.copy.leads',
    ],
    events: {
        publishes: [
            'relationships.contact-created.v1',
            'relationships.contact-updated.v1',
            'relationships.contact-deleted.v1',
            'relationships.contact-outbound-authorization-changed.v1',
            'relationships.organization-created.v1',
            'relationships.organization-updated.v1',
            'relationships.organization-deleted.v1',
            'relationships.lead-created.v1',
            'relationships.lead-updated.v1',
            'relationships.lead-converted.v1',
            'relationships.lead-cancelled.v1',
            'relationships.lead-lost.v1',
            'relationships.lead-deleted.v1',
            'relationships.customer-portal-intake-accepted.v1',
        ],
        subscribes: [],
    },
    server: {
        routes: [
            { id: 'relationships.routes.contacts', priority: 0 },
            { id: 'relationships.routes.organizations', priority: 0 },
            { id: 'relationships.routes.leads', priority: 0 },
            { id: 'relationships.routes.lead-scoring', priority: 0 },
            { id: 'relationships.routes.notes', priority: 0 },
            { id: 'relationships.routes.contact-note-snippets', requiredPermission: 'relationships.notes.create', priority: 10 },
        ],
        jobs: [],
        subscribers: [],
        slots: [{
                id: relationshipsInsuranceClaimsPartiesProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'relationships.contacts.read',
                priority: 0,
            }, {
                id: relationshipsFinanceCommissionAttributionsProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'relationships.referral-attributions.read',
                priority: 10,
            }, {
                id: relationshipsCustomerPortalIntakeAcceptanceProviderId,
                requiredCapability: platformOptionalActionProviderHostCapability,
                requiredPermission: 'relationships.contacts.update',
                priority: 20,
            }, {
                id: relationshipsAssistantContextProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'relationships.contacts.read',
                priority: 30,
            }, {
                id: relationshipsNoteMergeFieldsProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'relationships.contacts.read',
                priority: 40,
            }],
    },
    web: {
        routes: [
            { id: 'relationships.web.contact-detail', priority: 0 },
            { id: 'relationships.web.contacts', priority: 0 },
            { id: 'relationships.web.organizations', priority: 0 },
            { id: 'relationships.web.organization-detail', priority: 0 },
            { id: 'relationships.web.leads', priority: 0 },
        ],
        navigation: [
            { id: 'relationships.navigation.contacts', priority: 20 },
            { id: 'relationships.navigation.organizations', priority: 21 },
            { id: 'relationships.navigation.leads', priority: 22 },
        ],
        slots: [{
                id: 'relationships.web.projects.customer-panel',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'relationships.contacts.read',
                priority: 20,
            }],
    },
    mobile: { routes: [], slots: [] },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'relationships',
        owns: [
            'relationships.organizations',
            'relationships.contacts',
            'relationships.contact_email_addresses',
            'relationships.referral_sources',
            'relationships.leads',
            'relationships.lead_scoring_rules',
            'relationships.notes',
            'relationships.project_intake_contact_facts',
            'relationships.accept_customer_portal_intake_v1',
            'relationships.import_runs',
            'relationships.import_identity_map',
            'relationships.import_row_receipts',
            'relationships.import_rejects',
            'relationships.import_rollback_receipts',
            'relationships.verify_import_resolution_v1',
            'relationships.import_target_changes',
            'relationships.import_target_change_rollbacks',
            'relationships.import_evidence_immutable',
            'relationships.import_target_evidence_immutable',
            'relationships.import_canonical_json',
            'relationships.import_sha256',
            'relationships.import_timestamp_text',
            'relationships.import_deterministic_id',
            'relationships.import_payload_has_exact_keys',
            'relationships.import_target_canonical',
            'relationships.import_validate_target_payload',
            'relationships.import_receipt_json',
            'relationships.restore_import_target_v1',
            'relationships.restore_import_target_legacy_v1',
            'relationships.begin_import_run',
            'relationships.record_import_receipt',
            'relationships.record_import_reject',
            'relationships.complete_import_run',
            'relationships.fail_import_run',
            'relationships.rollback_import_run',
            'relationships.get_import_run',
            'relationships.get_import_run_evidence',
            'relationships.apply_import_target_v1',
            'relationships.apply_import_target_legacy_v1',
            'relationships.apply_contact_identity_import_target_v1',
            'relationships.rollback_import_target_v1',
            'relationships.project_contacts',
            'relationships.project_contact_import_runs',
            'relationships.project_contact_import_identity_map',
            'relationships.project_contact_import_receipts',
            'relationships.project_contact_import_changes',
            'relationships.project_contact_import_rollbacks',
            'relationships.project_contact_import_evidence_immutable',
            'relationships.project_contact_import_canonical_json',
            'relationships.project_contact_import_sha256',
            'relationships.project_contact_import_timestamp',
            'relationships.project_contact_import_receipt_json',
            'relationships.project_contact_import_canonical',
            'relationships.project_contact_import_payload_keys',
            'relationships.project_contact_import_assert_resolution',
            'relationships.begin_project_contact_import_v1',
            'relationships.apply_project_contact_import_v1',
            'relationships.rollback_project_contact_import_v1',
        ],
        readsThrough: ['projects.lead-intake.v1', 'projects.record-policy.v2', 'projects.import-resolution.v1'],
        migrations: [
            'relationships.contacts_foundation',
            'relationships.completion',
            'relationships.leads_foundation',
            'relationships.scoring_notes',
            'relationships.outbound_authorization_capability',
            'relationships.finance_commission_attributions',
            'relationships.customer-portal-intake-acceptance',
            'relationships.import-reconciliation',
            'relationships.import-target-writes',
            'relationships.import-resolution',
            'relationships.contact-identity-import',
            'relationships.project-contact-import',
        ],
    },
    health: ['relationships.database'],
    lifecycle: {
        initialization: { timeoutMs: 5_000, failureBehavior: 'quarantine-module' },
        resources: {
            requestConcurrency: 96,
            jobConcurrency: 0,
            queueBacklogLimit: 0,
            databaseConnectionBudget: 12,
            workerIsolation: 'shared-api',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'skip',
            events: {
                behavior: 'drop-safe',
                durableCursor: false,
                retentionDays: 0,
                backlogLimit: 0,
                warningAt: 0,
                reconciliationProcedure: null,
                dropSafeReason: 'The current Relationships slice publishes facts but owns no inbound event subscriber.',
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'finish-idempotently',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['relationships.database'],
            reconciliationProcedure: null,
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Relationships data remains stored while the optional module is disabled.',
});
//# sourceMappingURL=relationships.module.js.map